import "../../Events.js";

NS("UI.Plugin");

UI.Plugin.Base = Class(Events, {
    /** @type {UI.Element} */
    element: null,
    /** @type {Object} */
    options: null,

    isDestroyed: false,

    initialize: function(element, options) {
        this.element = element;

        _.merge(this, options);
    },

    destroy: function() {
        this.element = null;

        this.off();

        this.isDestroyed = true;

        return this;
    }
});
